interface ContentfulEntry {
  __typename: string
  key?: string
  value?: ContentfulValue
}

interface ContentfulValue {
  __typename: string
  stringValue?: string
  booleanValue?: boolean
  intValue?: number
  floatValue?: number
  mimeType?: string
  title?: string
  url?: string
  imageUrl?: string | null
  key?: string
  entries?: ContentfulEntry[]
  value?: ContentfulValue
  values?: ContentfulValue[]
}

export const contentfulTemplateMap: { [key: string]: string } = {
  // Landing Page spaces, each has their own space
  alta: '7a5k9v6bcoox',
  combos: 'nt8m1ya6i7ci',
  landingPage: '7a5k9v6bcoox',
  redVines: '8ueigqxvdhp2',

  // Experts Hiring Page spaces
  expertsPage: 'herory2ot5y9',
  pringles: '42aepvc7au4i',

  // About Us space
  teamPage: 'dk394eozxr14',

  // Deal.com space
  category: 'qt3sknillzby',
  faq: 'qt3sknillzby',
  loggedOutPdp: 'qt3sknillzby',
  openGraphTemplate: 'qt3sknillzby',
  returns: 'qt3sknillzby',
  giveawayLegalDisclosure: 'qt3sknillzby',

  // Engagement Channels space
  engagementModal: 'bia1kb6z62po',
  fullPageTakeover: 'bia1kb6z62po',
  prefillSMSModal: 'bia1kb6z62po',
  productFixedBar: 'bia1kb6z62po',
  smsModal: 'bia1kb6z62po'
}

function extractContentfulValue(value: ContentfulValue): ContentfulEntry {
  let retValue: any

  switch (value.__typename) {
    case 'ContentBooleanValue':
      retValue = value.booleanValue
      break

    case 'ContentStringValue':
      retValue = value.stringValue
      break

    case 'ContentIntValue':
      retValue = value.intValue
      break

    case 'ContentFloatValue':
      retValue = value.floatValue
      break

    case 'ContentAsset':
      retValue = {
        mimeType: value.mimeType,
        title: value.title,
        imageUrl: value.imageUrl || value.url
      }
      break

    case 'ContentValueArray':
      if (value.values) {
        retValue = value.values.map(entry => {
          return extractContentfulValue(entry)
        })
      }
      break

    case 'ContentObjectEntry':
      if (value.value) {
        retValue = extractContentfulValue(value.value)
      }
      break

    case 'ContentObject':
      if (value.entries) {
        retValue = value.entries.reduce((accu, value) => {
          if (!value.key || !value.value) {
            return {}
          }

          accu[value.key] = extractContentfulValue(value.value)

          return accu
        }, {} as { [key: string]: ContentfulEntry })
      }
      break
  }

  return retValue
}

export function createContentfulObject(data: ContentfulEntry[]) {
  let contentfulObject: {
    [key: string]: any
  } = {}

  data.forEach((entry: ContentfulValue) => {
    if (!entry.key || !entry.value) {
      return
    }

    contentfulObject[entry.key] = extractContentfulValue(entry.value)
  })

  return contentfulObject
}
